import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import ChangePlanPopupView from "views/settingsPage/ChangePlanPopupView";
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import Utils from "models/helper/Utils";
import ti18n from "i18n!nls/ChangePlanPopupi18n";
import RSVP from "rsvp";

const ChangePlanPopupController = Chaplin.Controller.extend({

    initialize: function(options) {
        _.extend(this, Backbone.Events);
        options = options || {};
        this._parentController = options.parentController || null;
        this._workspaceId = options.workspaceId || null;
        this._currentPlanType = options.currentPlanType || 'free';
        this._currentBillingCycle = options.currentBillingCycle || 'monthly';
        this._workspaceUsage = options.workspaceUsage || {};
        this._onSuccess = typeof options.onSuccess === 'function' ? options.onSuccess : null;
    },

    getModel: function() {
        return null;
    },

    getView: function() {
        return this.view;
    },

    onPopupClosed: function() {
        // Cleanup handled by view
    },

    handleConfirm: async function(selection) {
        if (!this._workspaceId) {
            window.alertErrorMessage(window.getI18n(ti18n, "CHANGE_PLAN_FAILED"));
            return;
        }
        var targetPlanType = selection && typeof selection === 'object'
            ? (selection.planType || selection.targetPlanType)
            : selection;
        var billingCycle = selection && typeof selection === 'object'
            ? (selection.billingCycle || 'monthly')
            : 'monthly';
        try {
            await TrebbleClientAPIHelper.getInstance().changeWorkspacePlan({
                workspaceId: this._workspaceId,
                targetPlanType: targetPlanType,
                billingCycle: billingCycle
            });
            window.alertSuccessMessage(window.getI18n(ti18n, "CHANGE_PLAN_SUCCESS"));
            if (this._onSuccess) {
                try {
                    await this._onSuccess();
                } catch (callbackError) {
                    console.error("Change plan onSuccess callback error:", callbackError);
                }
            }
            if (this.view) {
                this.view.close();
            }
        } catch (error) {
            console.error("Change workspace plan error:", error);
            var message = (error && error.message) ? error.message : window.getI18n(ti18n, "CHANGE_PLAN_FAILED");
            window.alertErrorMessage(window.getI18n(ti18n, "CHANGE_PLAN_FAILED"), message);
            throw error;
        }
    },

    handleCancelSubscription: async function() {
        if (!this._workspaceId) {
            window.alertErrorMessage(window.getI18n(ti18n, "CANCEL_SUBSCRIPTION_FAILED"));
            return;
        }
        var confirmed;
        try {
            confirmed = await Utils.getInstance().showUserConfirmationDialog(
                window.getI18n(ti18n, "CANCEL_SUBSCRIPTION_CONFIRM_TITLE"),
                window.getI18n(ti18n, "CANCEL_SUBSCRIPTION_CONFIRM_BODY")
            );
        } catch (confirmErr) {
            console.warn("Cancel subscription confirmation dialog error:", confirmErr);
            return;
        }
        if (confirmed !== true) {
            return;
        }
        try {
            await TrebbleClientAPIHelper.getInstance().cancelWorkspaceSubscription({
                workspaceId: this._workspaceId
            });
            window.alertSuccessMessage(window.getI18n(ti18n, "CANCEL_SUBSCRIPTION_SUCCESS"));
            if (this._onSuccess) {
                try {
                    await this._onSuccess();
                } catch (callbackError) {
                    console.error("Cancel subscription onSuccess callback error:", callbackError);
                }
            }
            if (this.view) {
                this.view.close();
            }
        } catch (error) {
            console.error("Cancel workspace subscription error:", error);
            var message = (error && error.message) ? error.message : window.getI18n(ti18n, "CANCEL_SUBSCRIPTION_FAILED");
            window.alertErrorMessage(window.getI18n(ti18n, "CANCEL_SUBSCRIPTION_FAILED"), message);
            throw error;
        }
    },

    buildModelAndRenderView: function() {
        return new RSVP.Promise((function(resolve, reject) {
            try {
                var params = {
                    currentPlanType: this._currentPlanType,
                    currentBillingCycle: this._currentBillingCycle,
                    workspaceUsage: this._workspaceUsage,
                    onConfirm: this.handleConfirm.bind(this),
                    onCancelSubscription: this.handleCancelSubscription.bind(this),
                    i18nModule: ti18n
                };
                this.view = new ChangePlanPopupView(params);
                this.listenTo(this.view, "closed", this.onPopupClosed);
                this.view.render();
                resolve();
            } catch (error) {
                reject(error);
            }
        }).bind(this));
    }
});

export default ChangePlanPopupController;
